const STAFF_ROLES = ["Admin", "Provider", "QA", "Supervisor"];

const parseRolesInput = (roles) => {
	if (Array.isArray(roles)) return roles;
	if (typeof roles === "string") {
		const trimmed = roles.trim();
		if (!trimmed) return [];
		if (trimmed.startsWith("[")) {
			try {
				const parsed = JSON.parse(trimmed);
				if (Array.isArray(parsed)) return parsed;
			} catch {
				// Fall through to single-role handling.
			}
		}
		return [trimmed];
	}
	return roles ? [roles] : [];
};

const normalizeStaffRoles = (roles) => {
	const source = parseRolesInput(roles);
	const normalized = [];
	for (const role of source) {
		const value = String(role || "").trim();
		if (STAFF_ROLES.includes(value) && !normalized.includes(value)) normalized.push(value);
	}
	return normalized;
};

const getStaffRoles = (staffItem) => {
	if (!staffItem) return [];
	const fromRoles = normalizeStaffRoles(staffItem.roles);
	if (fromRoles.length) return fromRoles;
	return normalizeStaffRoles(staffItem.role);
};

const getDisplayRole = (staffItem) => {
	const roles = getStaffRoles(staffItem);
	if (roles.length > 1) return roles.join(", ");
	const role = String(staffItem?.role || roles[0] || "").trim();
	return role || null;
};

const getStaffIdLabel = (roles) => {
	const normalized = normalizeStaffRoles(roles);
	if (normalized.includes("Provider")) return "Medicaid or MA Provider ID";
	if (normalized.includes("Admin")) return "Admin ID";
	if (normalized.includes("Supervisor")) return "Supervisor ID";
	if (normalized.includes("QA")) return "QA ID";
	return "Staff ID";
};

const hasProviderAccess = (staffItem) => getStaffRoles(staffItem).includes("Provider");

const resolveStaffStatus = (staffItem) => {
	if (staffItem?.accountStatus) return staffItem.accountStatus;
	if (staffItem?.signup_completed === false) return "Pending";
	if (staffItem?.membership_is_active === false || staffItem?.isactive === false) return "Inactive";
	if (staffItem?.isactive) return "Active";
	return "Inactive";
};

export {
	getDisplayRole,
	getStaffIdLabel,
	getStaffRoles,
	hasProviderAccess,
	normalizeStaffRoles,
	resolveStaffStatus,
	STAFF_ROLES,
};
